/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for alertminer-api services
 */
@Injectable({
  providedIn: 'root',
})
export class AlertminerApiConfiguration {
  rootUrl: string = '';
}
